import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";

const RadioSelectionsContext = createContext();

export const RadioSelectionsProvider = ({ children }) => {
  const [radioSelections, setRadioSelections] = useState([]);

  return (
    <RadioSelectionsContext.Provider value={{ radioSelections, setRadioSelections }}>
      {children}
    </RadioSelectionsContext.Provider>
  );
};
RadioSelectionsProvider.propTypes = {
  children: PropTypes.node,
};

export const useRadioSelections = () => {
  const context = useContext(RadioSelectionsContext);
  if (!context) {
    throw new Error("useRadioSelections must be used within a RadioSelectionsProvider");
  }
  return context;
};